import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventEmitter, Injectable, inject } from '@angular/core';
import { environment } from '../environments/environment';
import { Customer } from '../interface/customer';
import { Observable, catchError, of, switchMap, timeout } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  httpClient = inject(HttpClient);
  storageChanged = new EventEmitter<string>
  constructor(private http: HttpClient) { }

  private createHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': environment.angularAppUrl,
      'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE',
      'Access-Control-Allow-Headers': 'Content-Type, Authorization'
    });
  }
  get(url: string) {
    const headers = this.createHeaders();
    return this.http.get(url, { headers }).pipe(
      catchError((error) => {
        console.error('Error occurred while fetching data:', JSON.stringify(error));
        return of(error);
      })
    );
  }

  public post(url: string, body: any): Observable<any> {
    const headers = this.createHeaders();
    //console.log("Post URL - "+url+" PayLoad - "+JSON.stringify(body));
    return this.http.post(url, body, { headers }).pipe(timeout(90000), 
      catchError((error) => {
        console.error('Error occurred while fetching data:', error);
        return of(error);
      })
    );
  }

}
